import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as CommonConstants from '../../utils/common.constants';

@Injectable()
export class PharmacyService { 
  constructor(private http: HttpClient) {
  }
 
  save(saveData): Observable<any> {
    return this.http.post(CommonConstants.PHARMACY_SAVE, saveData).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getPharmaciesById(phamaId: number): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/partner/pharmacy/' + phamaId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }


  errorHandler(error: any): void {
    throwError(error);
  };

  searchPharmacies(practitioner, startIndex) {
    return this.http.post(CommonConstants.env + 'api/partner/pharmacy/search' + '?start=' + startIndex + '&size='
      + CommonConstants.PAGINATION_SIZE, practitioner)
  }
}
